export const BROWSER__RESIZE = 'BROWSER::RESIZE';

const initialState = {
  stageWidth: window.innerWidth,
  stageHeight: window.innerHeight,
};

export const windowResize = (stageWidth, stageHeight) => ({
  type: BROWSER__RESIZE,
  payload: {
    stageWidth,
    stageHeight,
  },
});

export default function browser(state = initialState, action) {
  switch (action.type) {
    case BROWSER__RESIZE:
      return {
        stageWidth: action.payload.stageWidth,
        stageHeight: action.payload.stageHeight,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/browser.js